<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">获取终端当前绑定信息</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			获取本机当前已关联[绑定]的项目/人员组信息。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">const char *__stdcall SKFaceGetDeviceBindInfo();</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">无</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	const char*类型，json格式字符串，表示本机当前FRM绑定信息
		</p>
		<pre class="doc_main_pre"><code class="doc_main_code">//Json示例：
{
    "project_key":"5ebe41fb0afd0a59631108370378",
    "project_name":"FRMtestzwcai",
    "server_url":"http://skfrm.sk-ai.com"
}
//含义：
{
    "project_key":绑定项目/分组的key,
    "project_name":绑定项目/分组的名称,
    "server_url":云端服务器地址
}</code></pre>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">const char *pszDeviceBindInfo = SKFaceGetDeviceBindInfo();</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Windows','FRM接口','获取终端当前绑定信息'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacewindows/frm/getBindInformation.vue